import styled from '@emotion/styled';

export const Container = styled.div`
    width: 100%;
    height: 100vh;
    background-color: ${({ theme }) => theme.color.black};
    display: flex;
    flex-direction: column;
`;
